module.exports = __webpack_public_path__ + "static/media/ch-box-1-norm.262eecfe.svg";